import type { AvatarProps, FormattedDateTimeProps, VanillaLinkProps } from '@_/ui';
import { Avatar, FormattedDateTime, Text } from '@_/ui';

export function CommentThreadBaseItem({
  actions,
  authorName,
  authorNameStr,
  avatarSrc,
  content,
  date,
  renderAuthorLink
}: {
  actions?: React.ReactNode;
  authorName: React.ReactNode;
  authorNameStr: AvatarProps['name'];
  avatarSrc?: string | null;
  content: React.ReactNode;
  date: FormattedDateTimeProps['value'];
  renderAuthorLink?: (props: VanillaLinkProps) => React.ReactNode;
}) {
  const author = (
    <Text size="sm" semibold>
      {authorName}
    </Text>
  );

  const authorLink = renderAuthorLink?.({ children: author, plain: true });

  return (
    <article className="relative flex items-stretch py-3">
      <div className="flex w-10 justify-center">
        <Avatar className="size-8" name={authorNameStr} src={avatarSrc} />
      </div>

      <div className="min-w-0 flex-1 px-2">
        <div className="flex h-6 items-center gap-x-2">
          <div>{authorLink || author}</div>

          <div>
            <Text size="xs" subdued>
              <FormattedDateTime relative value={date} />
            </Text>
          </div>
        </div>

        <div className="mt-1 text-sm text-gray-700">{content}</div>

        {!!actions && <div className="mt-3 ml-px flex items-center gap-x-6">{actions}</div>}
      </div>
    </article>
  );
}
